import { keyframes } from 'styled-components';
//////////////////////////////////////////////////

export const animation = keyframes`
  0% { box-shadow: 0 0 0px 0px #1f73a1 inset; }
  50% { box-shadow: 0 0 15px 4px #1f73a1 inset; }
  100% { box-shadow: 0 0 0px 0px #1f73a1 inset; }
`;
